/**
 * @module actions/address
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get schemas for current chain
 * @return {Promise} Axios promise
 */
export function getChainSchemas () {
  let url = API_URL + '/esg/chain/GetSchemas'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get selectable years for a civen schema
 * @return {Promise} Axios promise
 */
export function getSelectableSchemaYears (schemaId) {
  let url = API_URL + `/esg/chain/GetSelectableSchemaYears/${schemaId}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Post schema
 * @return {Promise} Axios promise
 */
export function postSchema (data) {
  let url = API_URL + '/esg/chain/PostSchema'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get companies associated with a given schemas at a specific year
 * @return {Promise} Axios promise
 */
export function getAssociatedCompanies (schemaId, year) {
  let url = API_URL + `/esg/chain/GetAssociatedCompanies/${schemaId}/${year}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Determine if a company have entered data to a schema on a specific year
 * @return {Promise} Axios promise
 */
export function getHaveCompanyEnteredData (schemaId, year, companyId) {
  let url = API_URL + `/esg/chain/GetHaveCompnyEnteredData/${schemaId}/${year}/${companyId}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Add a company to a specific shema year
 * @return {Promise} Axios promise
 */
export function postAddCompanyToSchema (schemaId, year, companyId) {
  let url = API_URL + `/esg/chain/AddCompanyToSchema/${schemaId}/${year}/${companyId}`
  return dispatch => {
    return axios.post(url)
  }
}

/**
 * @description Remove a company from a specific shema year
 * @return {Promise} Axios promise
 */
export function postRemoveCompanyFromSchema (schemaId, year, companyId) {
  let url = API_URL + `/esg/chain/RemoveCompanyFromSchema/${schemaId}/${year}/${companyId}`
  return dispatch => {
    return axios.post(url)
  }
}

/**
 * @description Create a new year of given schemas, either a copy of a year or as a new blank
 * @param copyFromYear Set to undefened to create a new blank year
 * @return {Promise} Axios promise
 */
export function postCreateNewChemaYear (schemaId, copyFromYear) {
  let url = API_URL + `/esg/chain/CreateNewChemaYear/${schemaId}/${copyFromYear}`
  return dispatch => {
    return axios.post(url)
  }
}

/**
 * @description Get scopes for a given schemas at a specific year
 * @return {Promise} Axios promise
 */
export function getScopesForYear (schemaId, year, type) {
  let url = API_URL + `/esg/chain/GetScopesForYear/${schemaId}/${year}/${type}`
  return dispatch => {
    return axios.get(url)
  }
}

export const ESGScopeTypes = {
  Default: 0,
  ManualReporting: 1
}

/**
 * @description Post a scope for a schema
 * @return {Promise} Axios promise
 */
export function postScope (scopeInfo) {
  let url = API_URL + `/esg/chain/PostScope`
  return dispatch => {
    return axios.post(url, scopeInfo)
  }
}

/**
 * @description Post a category for a scope
 * @return {Promise} Axios promise
 */
export function postCategory (categoryInfo) {
  let url = API_URL + `/esg/chain/PostCategory`
  return dispatch => {
    return axios.post(url, categoryInfo)
  }
}

/**
 * @description Post a line for a category
 * @return {Promise} Axios promise
 */
export function postLine (postInfo) {
  let url = API_URL + `/esg/chain/PostLine`
  return dispatch => {
    return axios.post(url, postInfo)
  }
}

/**
 * @description Get bool determining if one or more companies have entered data in a specific: Schema, Scope, Category or Line
 * @param level Schema = 0, Scope = 1, Category = 2, Line = 3
 * @return {Promise} Axios promise
 */
export function getIsDataEntered (level, id) {
  let url = API_URL + `/esg/chain/IsDataEntered/${level}/${id}`
  return dispatch => {
    return axios.get(url)
  }
}

export const ESGLevelTypes = {
  Schema: 0,
  Scope: 1,
  Category: 2,
  Line: 3
}

// Cmpany endpoints
/**
 * @description Get list of years the current company is associatet with
 * @return {Promise} Axios promise
 */
export function getCompanySchemaAssociations () {
  let url = API_URL + `/esg/company/getSchemaAssociations`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get list of scopes, categories and lines for the company at a given schema and year
 * @return {Promise} Axios promise
 */
export function getCompanyScopesForSchemaYear (schemaId, year, type) {
  let url = API_URL + `/esg/company/GetScopesForSchemaYear/${schemaId}/${year}/${type}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save company line data
 * @return {Promise} Axios promise
 */
export function postCompanyLine (companyLine) {
  let url = API_URL + `/esg/company/PostLine`
  return dispatch => {
    return axios.post(url, companyLine)
  }
}

/**
 * @description Determine if current company is using manual reporting for a given shema and year
 * @return {Promise} Axios promise
 */
export function getIsCompanyUsingManualReportingForSchemaYear (schemaId, year) {
  let url = API_URL + `/esg/company/GetIsUsingManualReporting/${schemaId}/${year}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Determine if current company is using manual reporting for a given shema and year
 * @return {Promise} Axios promise
 */
export function postIsCompanyUsingManualReportingForSchemaYear (schemaId, year, newValue) {
  let url = API_URL + `/esg/company/PostIsUsingManualReporting`
  return dispatch => {
    return axios.post(url, { schemaId, year, newValue })
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/esg.js